import {RouterStore} from 'mobx-react-router';
import {action} from 'mobx';

import AlertStore from './AlertStore';
import PersonaStore from './PersonaStore';
import SidebarStore from './SidebarStore';
import TemplateStore from './TemplateStore';

export default class RootStore {
  constructor(state){
    if (!state) return;
    if (state.persona) {
      this.personaStore.receiveData(state.persona);
    }
  }
  routerStore = new RouterStore();
  sidebarStore = new SidebarStore(this);
  alertStore = new AlertStore(this);
  personaStore = new PersonaStore(this);
  templateStore = new TemplateStore(this);

  // Fires on every route change
  // This feels a little weird but its better than doing things in components that can
  // be done here
  @action.bound
  watchHistory(location, action) {
    // If the server runs this...don't
    if (!location) return;
    if (['/about', '/'].includes(location.pathname)) {
      this.personaStore.resetPersona();
      return;
    }
    // Parse the pathname to get id and key
    const parsedPathname = location.pathname.split('/').filter((n) => (n));
    const id = parsedPathname[0] ? parsedPathname[0] : null;
    const key = parsedPathname[1] ? parsedPathname[1] : null;
    let changed = false;
    if (id && id !== this.personaStore.id) {
      this.personaStore.id = id;
      changed = true;
    }
    if (key && key !== this.personaStore.key) {
      this.personaStore.key = key;
      changed = true;
    }
    if (changed) {
      this.personaStore.getPersona();
    }
  }

}



// WEBPACK FOOTER //
// ./client/modules/RootStore.js